import { container } from '@/container';
import CONSTANTS from '@/helpers/constants';
import { Logger } from '@/services/Logger';
import { TripUpdateReq } from '@/services/signalr/MessageTypes/TripUpdateReq';
import { Signalr } from '@/services/signalr/Signalr';
import { IdValue } from '~/api/IdValue';

export interface TripReason {
  reasonType: string;
  reasonValue: IdValue;
  description?: string;
}

export interface AssignUnitToTripParams {
  trip: {
    id: string;
  };
  unitId: string;
  reason?: TripReason[];
  /** Trip status — use TRIPS.STATUS.PRE_ASSIGNED for pre-assignment (optional, defaults to assign) */
  tripStatus?: string;
  /** Shift ID to link the trip to (for pre-assignment tracking per ZD-20165) */
  shiftId?: string;
  /** Resource display name for toast messages (used when unitManager cannot resolve the name, e.g. inactive shifts) */
  resourceName?: string;
  /** FE-only flag echoed back via StatusMsg context so the toast can say "inactive shift" */
  isInactiveShift?: boolean;
}

export async function assignUnitToTrip(params: AssignUnitToTripParams): Promise<void> {
  const startMs = performance.now();
  try {
    const signalr = await container.getAsync(Signalr);
    await signalr.invoke(TripUpdateReq, {
      contextKey: CONSTANTS.UI.CONTEXTS.PENDING_ASSIGNMENTS,
      id: params.trip.id,
      unitId: params.unitId,
      TripReasons: params?.reason ?? [],
      ...(params.tripStatus ? { tripStatus: params.tripStatus } : {}),
      ...(params.shiftId ? { shiftId: params.shiftId } : {}),
      ...(params.resourceName ? { resourceName: params.resourceName } : {}),
      ...(params.isInactiveShift ? { isInactiveShift: true } : {}),
    });

    const logger = container.get(Logger);
    logger.track('trip.assign_unit', {
      durationMs: Math.round(performance.now() - startMs),
      success: true,
    });
  }
  catch (error) {
    const logger = container.get(Logger);
    logger.track('trip.assign_unit', {
      durationMs: Math.round(performance.now() - startMs),
      success: false,
      errorType: (error as Error).name,
    });
    logger.captureException(error as Error, { tags: { updateTrip: 'assignUnitToTrip' } });
    throw error;
  }
}
